import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import styles from './HomeCarousel.module.css';
import OptimizedPicture from '../OptimizedPicture/OptimizedPicture';

// Use original asset paths so our manifest-driven <OptimizedPicture> can emit AVIF/WebP srcsets.
const slidePaths = [
  'assets/carousel.jpg',
  'assets/carousel1.jpg',
  'assets/carousel2.jpg',
  'assets/carousel3.jpg',
];

export default function HomeCarousel() {
  return (
    <Carousel
      autoPlay
      infiniteLoop
      showThumbs={false}
      showStatus={false}
      swipeable
      emulateTouch
      className={styles.carousel}
    >
      {slidePaths.map((src, i) => (
        <div key={src}>
          <OptimizedPicture
            src={src}
            alt={`Slide ${i + 1}`}
            // LCP slide: eager & high priority
            priority={i === 0}
            sizes="100vw"
            style={{ width: '100%', height: '80vh', display: 'block' }}
          />
        </div>
      ))}
    </Carousel>
  );
}
